import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useTheme,
} from "@material-ui/core";
import React from "react";
import PaginationComponent from "../../components/pagination";
import { CollectionDataType, ISingleProductRecommendation } from "../../types";
import { AggregationRow } from "../aggregation/aggregation.table";

interface IProps {
  fields: { field: string; type: CollectionDataType }[];
  data: ISingleProductRecommendation["data"];
  currentPage: number;
  pageSize: number;
  total: number;
  handleNext: () => void;
  handlePrev: () => void;
  textColor?: "textSecondary" | "textPrimary";
  selectable?: boolean;
  multiSelect?: boolean;
  onSelect?: (values: string) => void;
  pagination?: boolean;
}

const RecommendationTable: React.FC<IProps> = ({
  fields,
  data,
  currentPage,
  pageSize,
  total,
  handleNext,
  textColor,
  handlePrev,
  selectable,
  multiSelect,
  onSelect,
  pagination,
}) => {
  const theme = useTheme();
  const color =
    textColor === "textSecondary"
      ? theme.palette.text.secondary
      : theme.palette.text.primary;
  return (
    <Box overflow="hidden" flexGrow={1} display="flex" flexDirection="column">
      {pagination && (
        <Box display="flex" alignItems="center">
          <Box
            display="flex"
            flexGrow={1}
            flexWrap="wrap"
            alignItems="center"
          />
          <PaginationComponent
            currentPage={currentPage}
            currentSize={data.length}
            handleNext={handleNext}
            handlePrev={handlePrev}
            pageSize={pageSize}
            total={total}
          />
        </Box>
      )}
      <Box overflow="auto">
        <Table>
          <TableHead>
            <TableRow>
              {selectable && <TableCell style={{ color }}>Select</TableCell>}
              {fields.map((x) => (
                <TableCell key={x.field} style={{ color }}>
                  {x.field}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((element) => (
              <AggregationRow
                fields={fields.map((x) => x.field)}
                value={element}
                rank={0}
                color={color}
                selectable={selectable}
                multiSelect={multiSelect}
                onSelect={(values) => onSelect && onSelect(values?._id)}
              />
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

RecommendationTable.defaultProps = {
  textColor: "textSecondary",
  onSelect: () => {},
  pagination: true,
};

export default RecommendationTable;
